import React, { useRef } from 'react';
import { logSearchFilterUsed } from '../../services/analytics';

const SearchFilter = ({ searchTerm, onSearchChange, ownerFilter, onOwnerChange, owners }) => {
    const debounceRef = useRef(null);

    const trackSearch = (newSearch, newOwner) => {
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            if (newSearch || newOwner) {
                logSearchFilterUsed({ search_term: !!newSearch, owner_filter: !!newOwner });
            }
        }, 800);
    };

    const handleSearchChange = (value) => {
        onSearchChange(value);
        trackSearch(value, ownerFilter);
    };

    const handleOwnerChange = (value) => {
        onOwnerChange(value);
        trackSearch(searchTerm, value);
    };

    return (
        <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 mb-6 transition-colors duration-200">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label htmlFor="search-tasks" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Search Tasks
                    </label>
                    <input
                        id="search-tasks"
                        type="text"
                        value={searchTerm}
                        onChange={(e) => handleSearchChange(e.target.value)}
                        placeholder="Search by task name..."
                        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500"
                    />
                </div>

                <div>
                    <label htmlFor="filter-owner" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Filter by Owner
                    </label>
                    <select
                        id="filter-owner"
                        value={ownerFilter}
                        onChange={(e) => handleOwnerChange(e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                    >
                        <option value="">All Owners</option>
                        {owners.map((owner) => (
                            <option key={owner} value={owner}>
                                {owner}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
};

export default SearchFilter;